import React, { useState, useEffect } from 'react';
import { Button, Icon } from '@sabre/spark-react-core';
import { array, func } from 'prop-types';
import { CSVLink } from 'react-csv';

const NewFaresError = ({ data, close }) => {
   const [errorData, SetErrorData] = useState([]);
   useEffect(() => {
      SetErrorData(data);
   }, [data]);
   useEffect(() => {
      SetErrorData(data);
   }, []);
   const handleDownloadClick = () => {
      SetErrorData(data);
      close();
   };
   return (
      <div className='new-fares-error-root-view'>
         <div className='row spark-bold export-conform-text'>
            Do you want to export saved fares error report ?
         </div>
         <div className='row spark-flex spark-pad-t-2 justify-end'>
            <CSVLink
               filename='Export fares details'
               data={errorData}
               onClick={() => handleDownloadClick()}
            >
               {' '}
               <Icon
                  name='file-download'
                  className='spark-pad-t-.5 spark-mar-r-2 cursor-pointer'
                  size='md'
                  style='fill'
                  label='distribution-group-open'
               />
            </CSVLink>
            <Button
               name='dg-cancel-button'
               className='spark-btn--secondary spark-mar-r-1'
               size={Button.SIZE.SMALL}
               onClick={close}
            >
               CANCEL
            </Button>
         </div>
      </div>
   );
};
NewFaresError.prototype = {
   data: array,
   close: func,
};

export default NewFaresError;
